module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入[委托名称]"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.page.criteria),
      callback: function($$v) {
        _vm.$set(_vm.page, "criteria", $$v)
      },
      expression: "page.criteria"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "clientName",
      "label": "委托方名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "simpleName",
      "label": "样品名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "basis",
      "label": "检验依据",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "items",
      "label": "检验项目",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "该检验是否与诉讼有关",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.Whether(scope.row.lawsuit)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "380"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.downPort(scope.$index, scope.row)
            }
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.href
          }
        }, [_vm._v("下载报告")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pull-right clearfix",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.totalsize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisibleComplaint
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisibleComplaint = $event
      }
    }
  }, [_c('el-form', {
    ref: "conData",
    attrs: {
      "model": _vm.conData,
      "rules": _vm.rules2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": "委托编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.conData.consignationId),
      callback: function($$v) {
        _vm.$set(_vm.conData, "consignationId", $$v)
      },
      expression: "conData.consignationId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "120px!important"
    },
    attrs: {
      "label": "满意程度选项"
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "width": "100px!important"
    },
    model: {
      value: (_vm.conData.checkList),
      callback: function($$v) {
        _vm.$set(_vm.conData, "checkList", $$v)
      },
      expression: "conData.checkList"
    }
  }, _vm._l((_vm.checkLists), function(report) {
    return _c('el-radio', {
      key: report,
      attrs: {
        "label": report
      }
    }, [_vm._v(_vm._s(report))])
  }), 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投诉或意见",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.conData.remark),
      callback: function($$v) {
        _vm.$set(_vm.conData, "remark", $$v)
      },
      expression: "conData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleComplaint = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addComplaintalert('conData')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisibleSatisfaction
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisibleSatisfaction = $event
      }
    }
  }, [_c('el-form', {
    ref: "conData2",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.conData2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": "委托编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.conData2.consignationId),
      callback: function($$v) {
        _vm.$set(_vm.conData2, "consignationId", $$v)
      },
      expression: "conData2.consignationId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满意度内容",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticStyle: {},
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.conData2.remark),
      callback: function($$v) {
        _vm.$set(_vm.conData2, "remark", $$v)
      },
      expression: "conData2.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleComplaint = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addSatisfactionalert('conData2')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c8f0b66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/consignation/placeOrderTable.vue
// module id = 1210
// module chunks = 10